import React, { useEffect, useState } from "react";
import DashboardShell from "../../components/DashboardShell";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Webhook as WHIcon } from "lucide-react";

export default function Webhooks() {
  const [hooks, setHooks] = useState([]);
  const [form, setForm] = useState({ url: "", events: "decision.denied,decision.flagged", secret: "" });

  const load = () => api.get("/v1/webhooks").then(r => setHooks(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.url) return toast.error("URL required");
    await api.post("/v1/webhooks", { url: form.url, events: form.events.split(",").map(s=>s.trim()), secret: form.secret });
    toast.success("Webhook added");
    setForm({ url: "", events: "decision.denied,decision.flagged", secret: "" });
    load();
  };

  const remove = async (id) => {
    await api.delete(`/v1/webhooks/${id}`);
    load();
  };

  return (
    <DashboardShell title="Webhooks" subtitle="Route high-severity events to Slack, PagerDuty, or your own endpoint.">
      <div className="grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-1 rounded-xl bg-white/5 border border-white/10 p-5">
          <div className="eyebrow text-[#FFD98A] mb-4" style={{fontSize:10}}>NEW WEBHOOK</div>
          <div className="space-y-3">
            <div>
              <label className="text-[11px] text-cream/60">URL</label>
              <input data-testid="webhook-url" value={form.url} onChange={e => setForm({...form, url: e.target.value})}
                placeholder="https://hooks.slack.com/…"
                className="w-full mt-1 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#FF6B35]/40" />
            </div>
            <div>
              <label className="text-[11px] text-cream/60">Events (comma-separated)</label>
              <input data-testid="webhook-events" value={form.events} onChange={e => setForm({...form, events: e.target.value})}
                className="w-full mt-1 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#FF6B35]/40" />
            </div>
            <div>
              <label className="text-[11px] text-cream/60">Signing secret</label>
              <input data-testid="webhook-secret" value={form.secret} onChange={e => setForm({...form, secret: e.target.value})}
                className="w-full mt-1 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#FF6B35]/40" />
            </div>
            <button data-testid="webhook-add" onClick={create} className="btn-primary w-full justify-center text-sm mt-2"><Plus size={14}/> Add webhook</button>
          </div>
        </div>
        <div className="lg:col-span-2 rounded-xl bg-white/5 border border-white/10 divide-y divide-white/5">
          {hooks.length === 0 && <div className="p-6 text-cream/50 text-sm">No webhooks yet.</div>}
          {hooks.map(h => (
            <div key={h.id} className="p-4 flex items-start gap-4">
              <WHIcon size={16} className="text-[#FF6B35] mt-1"/>
              <div className="flex-1 min-w-0">
                <div className="font-mono text-sm break-all">{h.url}</div>
                <div className="flex gap-2 mt-1 flex-wrap">
                  {h.events.map(e => <span key={e} className="chip chip-cream text-[10px]">{e}</span>)}
                </div>
              </div>
              <button onClick={() => remove(h.id)} className="btn-ghost-dark text-xs"><Trash2 size={12}/></button>
            </div>
          ))}
        </div>
      </div>
    </DashboardShell>
  );
}
